import React from "react";

import type { TicketTemplateConfig } from "../../types/rsvp";
import { ZoniqTicketFormBody } from "./ZoniqTicketFormBody";

type Props = {
  linkKind: "rsvp" | "guest_list";
  config: TicketTemplateConfig;
  promoters?: { id: string; name: string }[];
};

const PREVIEW_TIERS = [
  { id: "preview-ga", name: "General", price: 800, description: "Entry only" },
  { id: "preview-ga-plus", name: "GA+", price: 1500, description: "Entry + 1 drink" },
];

/** Read-only mock of the public signup form for template preview. */
export const TicketTemplatePreviewForm: React.FC<Props> = ({ linkKind, config, promoters = [] }) => {
  // Mirrors the real public pages. Guest List asks party size only and always
  // shows the promoter code as a mandatory bold field, whatever the template
  // says; RSVP shows tiers and honours the configured promoter display.
  const isGuestList = linkKind === "guest_list";
  const showPromoter = isGuestList || config.promoter_display !== "hidden";

  return (
    <ZoniqTicketFormBody
      tiers={isGuestList ? [] : PREVIEW_TIERS}
      partySizeOnly={isGuestList}
      selections={[{ id: "preview-sel", partySize: 2, tierId: isGuestList ? null : "preview-ga" }]}
      name=""
      phone=""
      email=""
      includePromoter={showPromoter}
      promoterDisplay={isGuestList ? "bold" : config.promoter_display}
      promoterRequired={isGuestList}
      promoterText={isGuestList ? (promoters[0]?.name ?? "") : ""}
      promoters={promoters}
      showPricing={!isGuestList}
      submitLabel="Get my pass"
      readOnly
    />
  );
};
